module.exports = __webpack_public_path__ + "static/assets/86fdc8f8beaed99051e246c424412026.svg";